<template>
  <div>
    <h1 class="text-2xl text-center font-bold mb-6">Finance</h1>
    <div class="">
      <div>Initial:</div>
      <div>{{ formatEuro(mortgage.initial) }}</div>
    </div>
    <div class="">
      <div>Interest Rate:</div>
      <div>{{ mortgage.interestRate }}%</div>
    </div>
    <div class="">
      <div>Years:</div>
      <div>{{ mortgage.years }}</div>
    </div>
    <div class="">
      <div>Start Date:</div>
      <div>{{ mortgage.startDate }}</div>
    </div>
    <div class="">
      <div>Payed off:</div>
      <div>{{ mortgage.payedOffLine }}</div>
    </div>
    <div class="">
      <div>Extra Payment:</div>
      <div>{{ formatEuro(mortgage.extraPayment) }}</div>
    </div>
    <table class="table-auto w-full">
      <thead>
        <tr>
          <th>Month</th>
          <th>Payment</th>
          <th>Interest</th>
          <th>Principal</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="payment in payments" :key="payment.month">
          <td>{{ payment.month }}</td>
          <td>{{ formatEuro(payment.monthlyPrincipalRepayment) }}</td>
          <td>{{ formatEuro(payment.monthlyInterestPayment) }}</td>
          <td>{{ formatEuro(payment.totalPayment) }}</td>
          <td>{{ formatEuro(payment.remainingBalance) }}</td>
        </tr>
      </tbody>
    </table>

    
  </div>
</template>

<script>

// import apiClient from '../axios'
import { onMounted, ref } from 'vue'

export default {
  name: 'FinanceView',
  components: {
  },
  setup() {
    const mortgage = ref({
      initial: 0,
      interestRate: 0,
      years: 0,
      startDate: new Date('2022-02-01'),
      payedOffLine: "", 
      extraPayment: 0,
      startExtraPayment: 2000,
    });
    const payments = ref([]);
    const loadFinance = async () => {
      
      try {
        // const { data } = await apiClient.get('/finance')

        // mortgage.value.initial = data.mortgageInitial
        // mortgage.value.interestRate = data.mortgageRate
        // mortgage.value.years = data.mortgageTerm
        // payments.value = data.dataMonthly

        mortgage.value.initial = 160050
        mortgage.value.interestRate = 1.45
        mortgage.value.years = 30
        mortgage.value.startDate = new Date('2022-02-01')

        mortgage.value.months = mortgage.value.years * 12
        mortgage.value.monthlyPrincipalRepayment = mortgage.value.initial / mortgage.value.months
        mortgage.value.extraPayment = 3200
        mortgage.value.startExtraPayment = 2025

        let balance = mortgage.value.initial
        while (balance > 0) {
          const monthlyInterestPayment = balance * mortgage.value.interestRate / 100 / 12
          const totalPayment = mortgage.value.monthlyPrincipalRepayment + monthlyInterestPayment
          const date = new Date(mortgage.value.startDate.setMonth(mortgage.value.startDate.getMonth() + 1))
          balance -= mortgage.value.monthlyPrincipalRepayment
          
          const currentYear = date.getFullYear()
          
          // If this is the last month of the year, pay the extra payment
          if (date.getMonth() === 11 && currentYear >= mortgage.value.startExtraPayment) {
            balance -= mortgage.value.extraPayment
          }

          // GEt the current year
          console.log(currentYear);


          payments.value.push({
            month: date.toLocaleDateString('nl-NL', { month: 'numeric', year: 'numeric' }),
            monthlyPrincipalRepayment: mortgage.value.monthlyPrincipalRepayment,
            monthlyInterestPayment,
            totalPayment,
            remainingBalance: balance
          })

          mortgage.value.endData = date;
          
        }
        const years = Math.floor(payments.value.length/12)
        const months = payments.value.length%12
        mortgage.value.payedOffLine = 'Payed off in ' + months + ' months and ' + years + ' years'
        // console.log(months,years,mortgage.value.payedOffLine);
      } catch (error) {
        console.error(error)
      }
    }


    onMounted(async () => {
      await loadFinance()
    })

    const formatEuro = (value) => {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value)
    }

    return {
      formatEuro,
      mortgage,
      payments,
    }
  }
}
</script>

<style>

</style>